import type { WireAuditRow } from '@/api/wire';

/**
 * What started an action (ADR-0058): one of three things a person began, or
 * the platform's own clock. An inbound message is never one, so it is never
 * shown as one. A person's own act needs no origin; a row from before the
 * gate says so rather than guessing.
 */
const STARTED: Record<string, string> = {
  chat: 'A person asked',
  confirmation: 'A person confirmed',
  assignment: 'An assignment',
  schedule: 'The schedule',
};

export function startedBy(r: Pick<WireAuditRow, 'origin' | 'actorType'>): string {
  if (r.origin) return STARTED[r.origin] ?? r.origin;
  return r.actorType === 'human' ? 'Themselves' : 'Not recorded';
}
